export default {
  apiKey: "AIzaSyAao2zHOSxxwUmLz1-jWtyZjplhMBzKp-A",
  authDomain: "heat-beaters-s88e.firebaseapp.com",
  projectId: "heat-beaters-s88e",
  storageBucket: "heat-beaters-s88e.appspot.com",
  messagingSenderId: "279745205186",
  appId: "1:279745205186:web:215ca89768728b534ffc5b"
};
